import { faMinus, faPlus } from "@fortawesome/pro-regular-svg-icons"
import { FontIcon } from "component/w24/component/FontIcon"
import { AnimatePresence, motion } from "framer-motion"
import { EColors, EFonts, EVariables } from "libs/style/w24_styling"
import { useIsWide } from "libs/utils/logic/responsiveLogic"
import React from "react"
import styled from "styled-components/macro"

interface Props {
  topics: {
    q: string
    a: string
  }[]
  className?: string
}

export const FAQ = (props: Props): JSX.Element => {
  const isWide = useIsWide()
  const [selectedIndex, setSelectedIndex] = React.useState<number>(-1)

  return (
    <S_FAQ className={props.className}>
      {props.topics.map((topic, index) => {
        return (
          <S_Topic
            key={topic.q}
            onClick={() => {
              if (index === selectedIndex) {
                setSelectedIndex(-1)
              } else {
                setSelectedIndex(index)
              }
            }}
          >
            <S_FontIcon
              icon={selectedIndex === index ? faMinus : faPlus}
              iconSize={isWide ? "20px" : "16px"}
              color={EColors.DARK}
            />
            <S_Right>
              <S_Title>{topic.q}</S_Title>

              <AnimatePresence>
                {selectedIndex === index && (
                  <S_Answer
                    key={topic.q}
                    initial={{ height: 0 }}
                    animate={{ height: "unset" }}
                    transition={{ duration: 0.2, ease: "easeInOut" }}
                    exit={{ height: 0 }}
                  >
                    {topic.a}
                  </S_Answer>
                )}
              </AnimatePresence>
            </S_Right>
          </S_Topic>
        )
      })}
    </S_FAQ>
  )
}

const S_Topic = styled.div`
  display: flex;
  gap: 18px;
  padding: 20px 25px;
  justify-content: flex-start;
  align-items: flex-start;
  border-bottom: 1px solid ${EColors.GREY2};
  cursor: pointer;
  user-select: none;
  &:last-child {
    border-bottom: none;
  }
  &:hover {
    background-color: ${EColors.GREY2};
  }

  @media only screen and (min-width: 1260px) {
    gap: 36px;
    padding: 33px 40px;
  }
`

const S_FAQ = styled.div`
  width: 100%;
  background-color: ${EColors.WHITE};
  border-radius: ${EVariables.Radius2};
  ${S_Topic}:nth-child(1) {
    border-top-left-radius: ${EVariables.Radius2};
    border-top-right-radius: ${EVariables.Radius2};
  }
  ${S_Topic}:last-child {
    border-bottom-left-radius: ${EVariables.Radius2};
    border-bottom-right-radius: ${EVariables.Radius2};
  }
`

const S_Answer = styled(motion.div)`
  color: ${EColors.DARK2};
  font-family: ${EFonts.Medium2};
  font-size: 15px;
  line-height: 28px;
  margin: 10px 0 0 0;
  overflow: hidden;
  @media only screen and (min-width: 1260px) {
    font-size: 16px;
    line-height: 31px;
  }
`

const S_FontIcon = styled(FontIcon)`
  flex-shrink: 0;
  height: fit-content;
  margin: 2px 0 0 0;
`

const S_Right = styled.div``

const S_Title = styled.div`
  color: ${EColors.DARK};
  font-family: ${EFonts.Medium};
  font-size: 15px;
  letter-spacing: -0.3px;
  line-height: 22px;
  @media only screen and (min-width: 1260px) {
    font-size: 18px;
    letter-spacing: -0.54px;
  }
`
